import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import translationEn from '../locales/en/translation.json';
import adviserHomePageEn from '../locales/en/adviserHomePage.json';
import memberDetailsEn from '../locales/en/memberDetails.json';

//the translations
const resources = {
    en: {
        translation: translationEn,
        adviserHomePage: adviserHomePageEn,
        memberDetails: memberDetailsEn,

        Graphs: adviserHomePageEn.Graphs,
        StaticHeader: adviserHomePageEn.StaticHeader,
        FUM: adviserHomePageEn.FUM,
        Members: adviserHomePageEn.Members,
        Fees: adviserHomePageEn.Fees,
        FeeDetails: adviserHomePageEn.FeeDetails,
        membersTable: adviserHomePageEn.Members.tableHeaders,
        feesTable: adviserHomePageEn.Fees.tableHeaders,
        feeDetailsTable: adviserHomePageEn.FeeDetails.tableHeaders,
        memberSite: memberDetailsEn.memberSite,
        personalDetails: memberDetailsEn.personalDetails,
        contributionDetails: memberDetailsEn.contributionDetails,
        balanceByAccount: memberDetailsEn.balanceByAccount,
        balanceDetails: memberDetailsEn.balanceDetails,
        AccountBalance: memberDetailsEn.AccountBalance,
        transactions: memberDetailsEn.transactions,
        futureStrategy: memberDetailsEn.futureStrategy,
        document: memberDetailsEn.document,
        contribution:memberDetailsEn.contribution
    }
};

i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: "en",
        keySeparator: false,
        interpolation: {
            escapeValue: false
        }
    });

export default i18n;
